export default __webpack_public_path__ + "static/logo-white-e04e855403b35498284a4e716b798c63.svg";